// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__Y77Qw","logo":"header_logo__HtjWP","menusWrapper":"header_menusWrapper__ciY2_"};